import React, { useEffect, useState } from "react";
import { PageContent } from "../../styles/global/Pages.styled"
import { ConfigurationsSubTabs } from "../Global/Organism/Configurations/ConfigurationsSubTabs";
import { Sidebar } from '../App/SideBar';
import styled from "styled-components";
import Theme from "../../styles/Theme/Theme";
import { Footer } from "../App/Footer";
import { BuildingHeader } from "../Global/Molecules/BuildingDetails/BuildingHeader";
import { ConfigurationHeader } from "../Global/Molecules/Configurations/ConfigurationHeader";
import { Navigate, Route, redirect, useLocation } from "react-router";
import { useAuthContext } from "../../contexts/AuthContext";
import { PublicRoute } from "../App/Routes/PublicRoutes";
import { LoginScreen } from "../App/LoginScreen";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100%;
  background-color: ${Theme.color["neutral-1"]};
`;

const RightContent = styled.div`
 display:flex;
 flex-direction:column;
 justify-content:space-between;
  width: calc(100% - 235px);
  overflow-y:auto;
  .tab_component_children {
    padding: ${Theme.spacing.s05};
    box-sizing: border-box;
  }
`;

const SegmentedWarper = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  justify-content: center;
  margin-top: 1%;
`;

const SegmentedControlStyle = styled.div`
  display: flex;
  background-color: ${Theme.color["white"]};
  border-radius: 30px;
  /* box-shadow: ${Theme.shadow.level3}; */
  height: 45px; //50px
  gap: 10px; //20px
  padding: 0 10px;
`;

export const Configurations = () => {
    // const { tags } = useAuthContext();
    const tags = JSON.parse(localStorage.getItem('mico_tags'));
    const location = useLocation();

    const [currentTab, setCurrentTab] = useState(
        location.hash
            ? location.hash.replace("#", "")
            : findFirstAllowed(tags, ConfigurationsSubTabs)?.label
    );
    const tabItem = ConfigurationsSubTabs.find(
        (entry) => entry.label === currentTab
    );

    const getComponentByTab = () => {
        //Verifica qual o index the sub tab selecionada dentro do header, para depois renderizar o componente correto.
        let item = tabItem;
        if (item == undefined || item == null)
            item = findFirstAllowed(tags, ConfigurationsSubTabs)
        if (item == undefined)
            return undefined;
        if (!item?.buttons)
            return item.component;
        const headerTabIndex = item.buttons.findIndex(
            (x) => x === headerSelectedTab
        );
        const finalHeaderTabIndex = headerTabIndex >= 0 ? headerTabIndex : 0;
        return item?.component[finalHeaderTabIndex];
    };

    const [headerSelectedTab, setHeaderSelectedTab] = useState(
        tabItem?.buttons?.[0]
    );

    const changeHeaderSelectedTab = (headerTab) => {
        setHeaderSelectedTab(headerTab);
    };

    if (location.hash === "") {
        window.location.hash = "#" + currentTab;
    }

    const OpenTabComponent = getComponentByTab();
    if (OpenTabComponent == undefined) {
        return
    }

    return (
        // <PageContent>
        <Wrapper>
            <Sidebar
                sideBarMenu={ConfigurationsSubTabs.filter(e => tags?.includes(e.label))}
                activeTab={currentTab}
                setCurrentTab={setCurrentTab}
            />
            <RightContent>
                <div>
                    {tabItem?.buttons && tabItem?.buttons?.length > 1 ?
                        <ConfigurationHeader
                            buttons={tabItem.buttons}
                            changeHeaderSelectedTab={changeHeaderSelectedTab}
                        />
                        : null}
                    <OpenTabComponent
                        headerSelectedTab={headerSelectedTab}
                        className={"tab_component_children"}
                    />
                </div>
                <Footer />
            </RightContent>
        </Wrapper>
        // </PageContent>
    )
}

function findFirstAllowed(tags, ConfigurationsSubTabs) {
    const res = ConfigurationsSubTabs.filter(value => tags.includes(value.name.toLowerCase()))
    if (res.length > 0)
        return res[0];
    else
        return undefined
}